// Bet actions
export const SELECT_FOOTBALL_BET_TYPE = 'SELECT_FOOTBALL_BET_TYPE';



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/modules/football/constants/actionTypes.js